import { Check } from "lucide-react";
import Modal from "../../../components/Modal/Modal";
import StatusChip from "../../../components/StatusChip/StatusChip";
import ApprovalRemarks from "./ApprovalRemarks";

/** Read-only view of the approval: who approved, when, and their remarks. */
const PrincipalRemarksModal = ({ isOpen, diary, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Principal's Remarks" size="md">
    <StatusChip tone="success" icon={<Check size={12} />}>
      Approved
    </StatusChip>
    <ApprovalRemarks diary={diary} />
  </Modal>
);

export default PrincipalRemarksModal;
